import React from "react";
import { Box, CircularProgress, Avatar } from "@material-ui/core";

/**
 * @typedef {Object} Props
 * @property {number} [tamanho=120]
 */
/**
 *
 * @param {React.ComponentPropsWithoutRef<"div"> & Props} props
 * @returns
 */

export default function Loading({ tamanho = 120, exibirLogo = false, ...props }) {
    const imageURL = `${process.env.PUBLIC_URL}/loader_icone.png`;

    return (
        <Box component={"div"} {...props}>
            <CircularProgress
                size={tamanho}
                style={{
                    margin: "auto",
                    position: "absolute",
                    top: "0",
                    right: "0",
                    left: "0",
                    bottom: "0",
                    zIndex: 1,
                }}
            />

            {exibirLogo ?
                <Avatar
                    alt="Imagem"
                    src={imageURL}
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        overflow: 'visible',
                        zIndex: 2,
                        width: 'auto',
                        height: 'auto',
                        maxWidth: '125px',
                        maxHeight: '125px',
                        alignContent: 'center'
                    }}
                />
                : null}
        </Box>
    );
}
